import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b082bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = {
  class: "form-item flex-ter-bwn",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = { class: "form-item-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_5 = { class: "form-item-content" }
const _hoisted_6 = { class: "form-item-radio-content flex-ter" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = {
  class: "form-item flex-ter-bwn",
  style: {"margin-bottom":"10px"}
}
const _hoisted_10 = { class: "form-item-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_12 = { class: "form-item-content" }
const _hoisted_13 = { class: "form-item-radio-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "submit-btn abs flex" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useRule } from '@/util/useRules'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { ElMessage } from 'element-plus'
import { useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'adt', 'isBackSku'],
  emits: ['change', 'close'],
  setup(__props, { emit }) {

const props = __props


const spotNum: any = ref('')
const spotStatus = ref(0)
const changeNum = () => {
  const n = Number(spotNum.value.replaceAll(/\D/g, '') || 0)
  if (n) {
    spotNum.value = Number(n) > 99 ? 99 : n
  } else {
    spotNum.value = ''
  }
}
watch(() => props.adt, () => {
  console.log('props.adt.spotCheckRatio', props.adt.spotCheckRatio)
  spotStatus.value = props.adt.spotCheckFlag && props.adt.spotCheckRatio ? 1 : 0
  spotNum.value = props.adt.spotCheckRatio && props.adt.spotCheckRatio !== '-' ? Math.round(props.adt.spotCheckRatio * 100) : ''
}, {
  immediate: true,
  deep: true
})
const info = ref('')

const change = (v:boolean) => {
  if (v) {
    if (spotStatus.value === 1 && !spotNum.value) {
      ElMessage.warning(t('请填写抽检比例'))
      return
    }
    props.adt.spotCheckFlag = spotStatus.value
    props.adt.spotCheckRatio = spotStatus.value === 0 ? '' : spotNum.value / 100
  } else {
    // 取消后重置状态
    props.adt.spotCheckFlag = 0
    props.adt.spotCheckRatio = ''
  }
  emit('change', v)
  setTimeout(() => {
    emit('close')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "el-zoom-in-top",
    duration: 500
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["content rel", _unref(useSite)()])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(_toDisplayString(_unref(t)('范围')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: spotStatus.value === 0 }, 'form-item-radio-item flex-ter']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (spotStatus.value = 0))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(spotStatus.value === 0 ? 'iconfont icon-xuanzhong1' : 'iconfont icon-moren1')
                  }, null, 2),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('全检1')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: spotStatus.value === 1 }, 'form-item-radio-item flex-ter']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (spotStatus.value = 1))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(spotStatus.value === 1 ? 'iconfont icon-xuanzhong1' : 'iconfont icon-moren1')
                  }, null, 2),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('抽检')), 1)
                ], 2)
              ])
            ])
          ]),
          (spotStatus.value === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(_unref(t)('抽检比例')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_input, {
                        onInput: changeNum,
                        modelValue: spotNum.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((spotNum).value = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-tip flex", _unref(useSite)()])
                }, [
                  _hoisted_14,
                  _createElementVNode("span", {
                    class: "tip-text",
                    innerHTML: _unref(t)('抽检数量根据比例向上取整；选择抽检如发生次品，则无法发起售后')
                  }, null, 8, _hoisted_15)
                ], 2)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_button, {
            class: "btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (change(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (change(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})